var isType = require('./is-type');

var isArray = Array.isArray ? Array.isArray : function (value) {
  return isType(value, 'Array');
};
module.exports = isArray;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-array.js
// module id = 5
// module chunks = 0